// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-list[data-v-792dade8]{margin:0 -9px;display:flex;list-style:none}.item[data-v-792dade8]{padding-left:9px;padding-right:9px}.share-btn[data-v-792dade8]{min-width:unset;width:35px;height:35px;padding:8px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
